var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"pt-30 mt-30 pl-30 pr-48 d-flex justify-content-between",attrs:{"show":true,"variant":"alert alert-card alert-success"}},[_c('div',[_c('h3',[_vm._v("Payment Confirmed close this")])]),_c('i',{staticClass:"text-50 text-success i-Yes"})])
}
var staticRenderFns = []

export { render, staticRenderFns }